import React from "react";
import { Row, Col } from "antd";

import ZenDonut from "../Common/Graph/ZenDonut";
import ZenGauge from "../Common/Graph/ZenGauge";
import ZenVerBarChart from "../Common/Graph/ZenVerBarChart";

import liracrypt from "../../Liracrypt/liracrypt";
// import liracrypt from "../../../../../src/components/Liracrypt/liracrypt";
import SessionError from "../../ApiErrorComp/SessionError";
import ApiErrorComp from "../../ApiErrorComp/ApiErrorComp";
import RoutePage from "../../RoutePage";

class SnippetLinePerformanceAv extends React.Component {
  state = {
    ZenSampleChart: null,

    // SnippetLineZenGaugeAPQ_AV: null,
    // SnippetLineZenGaugeAPQ_PE: null,
    // SnippetLineZenGaugeAPQ_QA: null,
    // SnippetLineZenDonutTimeDistribution: null,
    // SnippetLineZenVerBarChartHourlyOEE: null,
    // SnippetLineZenVerBarChartHourlyAV: null,
    // SnippetLineZenVerBarChartHourlyPE: null,
    // SnippetLineZenVerBarChartHourlyQA: null,
    // SnippetLineZenVerBarChartContributorsPE: null,
    // SnippetLineZenDonutLossTimePE: null,
    // SnippetLineZenVerBarChartContributorsQA: null,
    // SnippetLineZenDonutLossTimeQA: null,
    // SnippetLineZenVerBarChartContributorsAV: null,
    // SnippetLineZenDonutLossTimeAV: null,

    loading: true,
    loginError: false,
    dataLoading: false,
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  componentDidMount() {
    this.props.setPageHeader("Line Performance Stats");
    this._isMounted = true;
    this.fetchTrendData();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.loginError = false;
  }

  fetchTrendData = () => {
    liracrypt
      // .get("/textapi", {
      //   dn: "ContainerChartDonut",
      // })
      .get("/chart/charttemplate", { chartGroup: "ZenSampleChart" } || {})
      // .get("test", { } || {})
      .then(({ data }) => {
        const resp = { ...data };
        let respData = {};
        respData["ZenSampleChart"] =
          resp["data"]["ZenSampleChart"];
        // respData["SnippetLineZenGaugeAPQ_AV"] =
        //   resp["data"]["SnippetLineZenGaugeAPQ_AV"];
        // respData["SnippetLineZenGaugeAPQ_PE"] =
        //   resp["data"]["SnippetLineZenGaugeAPQ_PE"];
        // respData["SnippetLineZenGaugeAPQ_QA"] =
        //   resp["data"]["SnippetLineZenGaugeAPQ_QA"];
        // respData["SnippetLineZenDonutTimeDistribution"] =
        //   resp["data"]["SnippetLineZenDonutTimeDistribution"];
        // respData["SnippetLineZenVerBarChartHourlyOEE"] =
        //   resp["data"]["SnippetLineZenVerBarChartHourlyOEE"];
        // respData["SnippetLineZenVerBarChartHourlyAV"] =
        //   resp["data"]["SnippetLineZenVerBarChartHourlyAV"];
        // respData["SnippetLineZenVerBarChartHourlyPE"] =
        //   resp["data"]["SnippetLineZenVerBarChartHourlyPE"];
        // respData["SnippetLineZenVerBarChartHourlyQA"] =
        //   resp["data"]["SnippetLineZenVerBarChartHourlyQA"];
        // respData["SnippetLineZenVerBarChartContributorsPE"] =
        //   resp["data"]["SnippetLineZenVerBarChartContributorsPE"];
        // respData["SnippetLineZenDonutLossTimePE"] =
        //   resp["data"]["SnippetLineZenDonutLossTimePE"];
        // respData["SnippetLineZenVerBarChartContributorsQA"] =
        //   resp["data"]["SnippetLineZenVerBarChartContributorsQA"];
        // respData["SnippetLineZenDonutLossTimeQA"] =
        //   resp["data"]["SnippetLineZenDonutLossTimeQA"];
        //   respData["SnippetLineZenVerBarChartContributorsAV"] =
        //   resp["data"]["SnippetLineZenVerBarChartContributorsAV"];
        // respData["SnippetLineZenDonutLossTimeAV"] =
        //   resp["data"]["SnippetLineZenDonutLossTimeAV"];

        respData["mainData"] = { ...resp };
        this._isMounted &&
          this.setState(
            {
              ...this.state,
              ...respData,
              loading: false,
              dataLoading: false,
            },
            () => {
              // console.log(this.state.dailyTrend);
            }
          );
      })
      .catch((error) => {
        // message.error('ERROR: Unable to save!', 4);
        console.log(error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            this.setState({
              ...this.state,
              loginError: true,
            });
          }
        }
      });
  };

  render() {
    if (this.state.mainData) {
      return (
        <div>
          <Row style={{ background: "#000000" }}>
            <Col style={{ width: "25%" }}>
              <div
                style={{
                  borderRadius: "10px",
                  background: "#191C24",
                  border: "1px solid #3c3e4f",
                  margin: "10px 10px 10px 10px",
                  width: "93%",
                }}
              >
                <Row>

                  <ZenGauge
                    divId={"SnippetLineZenGaugeOEE"}
                    api={"/snippet/apqo"}
                    urlData={{
                      chartGroup: "SnippetLineOee","dictName": "GaugeOEE"
                    }}
                    onChange={(data) => this.changeBasicGraph(data)}
                  />
                </Row>

                {/* <Row>
                  <Col style={{ width: "30%" }}>
                    <ZenGauge
                      divId={"SnippetLineZenGaugeAPQ_AV"}
                      data={this.state.SnippetLineZenGaugeAPQ_AV.data}
                      config={this.state.SnippetLineZenGaugeAPQ_AV.config}
                      onChange={(data) => this.changeBasicGraph(data)}
                    />
                  </Col>
                  <Col style={{ width: "30%" }}>
                    <ZenGauge
                      divId={"SnippetLineZenGaugeAPQ_PE"}
                      data={this.state.SnippetLineZenGaugeAPQ_PE.data}
                      config={this.state.SnippetLineZenGaugeAPQ_PE.config}
                      onChange={(data) => this.changeBasicGraph(data)}
                    />
                  </Col>
                  <Col style={{ width: "30%" }}>
                    <ZenGauge
                      divId={"SnippetLineZenGaugeAPQ_QA"}
                      data={this.state.SnippetLineZenGaugeAPQ_QA.data}
                      config={this.state.SnippetLineZenGaugeAPQ_QA.config}
                      onChange={(data) => this.changeBasicGraph(data)}
                    />
                  </Col>
                </Row> */}
              </div>
            </Col>
            {/* <Col style={{ width: "25%" }}>
              <div
                style={{
                  borderRadius: "10px",
                  background: "#191C24",
                  border: "1px solid #3c3e4f",
                  margin: "10px 10px 10px 10px",
                  width: "95%",
                }}
              >
                <ZenDonut
                  divId={"SnippetLineZenDonutTimeDistribution"}
                  data={this.state.SnippetLineZenDonutTimeDistribution.data}
                  config={this.state.SnippetLineZenDonutTimeDistribution.config}
                  onChange={(data) => this.changeBasicGraph(data)}
                />
              </div>
            </Col> */}
            {/* <Col style={{ width: "50%" }}>
              <div
                style={{
                  borderRadius: "10px",
                  background: "#191C24",
                  border: "1px solid #3c3e4f",
                  margin: "10px 10px 10px 10px",
                  width: "95%",
                }}
              >
                <ZenVerBarChart
                  divId={"SnippetLineZenVerBarChartHourlyOEE"}
                  data={this.state.SnippetLineZenVerBarChartHourlyOEE.data}
                  config={this.state.SnippetLineZenVerBarChartHourlyOEE.config}
                  onChange={(data) => this.changeBasicGraph(data)}
                />
              </div>
            </Col> */}
          </Row>
          {/* <Row style={{ background: "#000000" }}>
            <Col style={{ width: "37.5%" }}>
              <div
                style={{
                  borderRadius: "10px",
                  background: "#191C24",
                  border: "1px solid #3c3e4f",
                  margin: "10px 10px 10px 10px",
                  width: "95%",
                }}
              >
                <ZenVerBarChart
                  divId={"SnippetLineZenVerBarChartHourlyPE"}
                  data={this.state.SnippetLineZenVerBarChartHourlyPE.data}
                  config={this.state.SnippetLineZenVerBarChartHourlyPE.config}
                  onChange={(data) => this.changeBasicGraph(data)}
                />
              </div>
            </Col>
            <Col style={{ width: "37.5%" }}>
              <div
                style={{
                  borderRadius: "10px",
                  background: "#191C24",
                  border: "1px solid #3c3e4f",
                  margin: "10px 10px 10px 10px",
                  width: "95%",
                }}
              >
                <ZenVerBarChart
                  divId={"SnippetLineZenVerBarChartContributorsPE"}
                  data={this.state.SnippetLineZenVerBarChartContributorsPE.data}
                  config={
                    this.state.SnippetLineZenVerBarChartContributorsPE.config
                  }
                  onChange={(data) => this.changeBasicGraph(data)}
                />
              </div>
            </Col>
            <Col style={{ width: "25%" }}>
              <div
                style={{
                  borderRadius: "10px",
                  background: "#191C24",
                  border: "1px solid #3c3e4f",
                  margin: "10px 10px 10px 10px",
                  width: "95%",
                }}
              >
                <ZenDonut
                  divId={"SnippetLineZenDonutLossTimePE"}
                  data={this.state.SnippetLineZenDonutLossTimePE.data}
                  config={this.state.SnippetLineZenDonutLossTimePE.config}
                  onChange={(data) => this.changeBasicGraph(data)}
                />
              </div>
            </Col>
          </Row> */}
          {/* <Row style={{ background: "#000000" }}>
            <Col style={{ width: "37.5%" }}>
              <div
                style={{
                  borderRadius: "10px",
                  background: "#191C24",
                  border: "1px solid #3c3e4f",
                  margin: "10px 10px 10px 10px",
                  width: "95%",
                }}
              >
                <ZenVerBarChart
                  divId={"SnippetLineZenVerBarChartHourlyQA"}
                  data={this.state.SnippetLineZenVerBarChartHourlyQA.data}
                  config={this.state.SnippetLineZenVerBarChartHourlyQA.config}
                  onChange={(data) => this.changeBasicGraph(data)}
                />
              </div>
            </Col>
            <Col style={{ width: "37.5%" }}>
              <div
                style={{
                  borderRadius: "10px",
                  background: "#191C24",
                  border: "1px solid #3c3e4f",
                  margin: "10px 10px 10px 10px",
                  width: "95%",
                }}
              >
                <ZenVerBarChart
                  divId={"SnippetLineZenVerBarChartContributorsQA"}
                  data={this.state.SnippetLineZenVerBarChartContributorsQA.data}
                  config={
                    this.state.SnippetLineZenVerBarChartContributorsQA.config
                  }
                  onChange={(data) => this.changeBasicGraph(data)}
                />
              </div>
            </Col>
            <Col style={{ width: "25%" }}>
              <div
                style={{
                  borderRadius: "10px",
                  background: "#191C24",
                  border: "1px solid #3c3e4f",
                  margin: "10px 10px 10px 10px",
                  width: "95%",
                }}
              >
                <ZenDonut
                  divId={"SnippetLineZenDonutLossTimeQA"}
                  data={this.state.SnippetLineZenDonutLossTimeQA.data}
                  config={this.state.SnippetLineZenDonutLossTimeQA.config}
                  onChange={(data) => this.changeBasicGraph(data)}
                />
              </div>
            </Col>
          </Row> */}
          {/* <Row style={{ background: "#000000" }}>
            <Col style={{ width: "37.5%" }}>
              <div
                style={{
                  borderRadius: "10px",
                  background: "#191C24",
                  border: "1px solid #3c3e4f",
                  margin: "10px 10px 10px 10px",
                  width: "95%",
                }}
              >
                <ZenVerBarChart
                  divId={"SnippetLineZenVerBarChartHourlyAV"}
                  data={this.state.SnippetLineZenVerBarChartHourlyAV.data}
                  config={this.state.SnippetLineZenVerBarChartHourlyAV.config}
                  onChange={(data) => this.changeBasicGraph(data)}
                />
              </div>
            </Col>
            
          </Row> */}
          {/* <Row style={{ background: "#000000" }}>
            <Col style={{ width: "37.5%" }}></Col>
            <Col style={{ width: "37.5%" }}>
              <div
                style={{
                  borderRadius: "10px",
                  background: "#191C24",
                  border: "1px solid #3c3e4f",
                  margin: "10px 10px 10px 10px",
                  width: "93%",
                }}
              >
                <Row>
                  <RoutePage route="/format/zentable" params={{ a: "b" }} />
                </Row>
              </div>
            </Col>
            <Col style={{ width: "25%" }}></Col>
          </Row> */}
        </div>
      );
    } else {
      return (
        <>
          {" "}
          <SessionError visible={this.state.loginError} />
          <div className="contentEmpty"></div>
        </>
      );
    }
  }
}
export default SnippetLinePerformanceAv;
